<template>
  <div class="pdv-delivery-wrap">
    <el-form label-position="right" label-width="120px">
      <div class="pdv-panel">
        <PdvDeliverySender
          ref="senderData"
          @focus="focus"
          @calculate="calculate"
          :customer="customer"
          :licence="licence"
        />
      </div>
      <div class="pdv-panel">
        <PdvDeliveryData
          ref="deliveryData"
          @focus="focus"
          @calculate="calculate"
          :customer="customer"
          :licence="licence"
        />
      </div>
      <div class="pdv-panel">
        <PdvDeliveryObject
          ref="objectData"
          @focus="focus"
          @calculate="calculate"
          @open="opendc"
          @volume="openvolume"
        />
      </div>
      <div class="pdv-panel">
        <PdvDeliveryServices
          ref="servicesData"
          :tableData="values"
          @create="create"
        />
      </div>
      <PdvPrePostVolume ref="volume" v-on:saved="volume" />
      <PdvPrePostDC ref="dc" v-on:saved="saved" />
    </el-form>
  </div>
</template>

<script>
import { PrepostService } from "@/services/customers/prepost.services";
import { MotoboyService } from "@/services/customers/motoboy.services";
import { ValuesPrepostService } from "@/services/customers/values.prepost.services";
import PdvDeliverySender from "./delivery/PdvDeliverySender";
import PdvDeliveryData from "./delivery/PdvDeliveryData";
import PdvDeliveryObject from "./delivery/PdvDeliveryObject";
import PdvDeliveryServices from "./delivery/PdvDeliveryServices";
import PdvPrePostDC from "./delivery/PdvPrePostDC";
import PdvPrePostVolume from "./delivery/PdvPrePostVolume";

import ZipMixins from "@/xpost/mixins/zipcode";
export default {
  mixins: [ZipMixins],
  name: "PdvCallDelivery",
  props: ["customer", "name", "phone", "mail", "licence"],
  components: {
    PdvDeliverySender,
    PdvDeliveryData,
    PdvDeliveryObject,
    PdvDeliveryServices,
    PdvPrePostDC,
    PdvPrePostVolume,
  },
  computed: {
    ruleForm() {
      const vm = this;
      return {
        senderData: vm.$refs.senderData.ruleForm,
        deliveryData: vm.$refs.deliveryData.ruleForm,
        objectData: vm.$refs.objectData.ruleForm,
        servicesData: vm.values,
      };
    },
  },
  data() {
    return {
      values: [],
      dc: [],
      volumes: [],
    };
  },
  methods: {
    openvolume() {
      console.log("openvolume", this.$refs.objectData);
      const { ruleForm } = this.$refs.objectData;
      const { height, width, length } = ruleForm;
      this.$refs.volume.open(height, width, length);
    },
    volume(list) {
      this.volumes = list;
    },
    opendc() {
      this.$refs.dc.open();
    },
    saved(data) {
      this.dc = data;
    },
    startup(form) {
      this.$refs.senderData.startup(form.senderData);
      this.$refs.deliveryData.startup(form.deliveryData);
      this.$refs.objectData.startup(form.objectData);
      this.values = form.servicesData;
    },
    clear() {
      const vm = this;
      vm.$refs.senderData.clear();
      vm.$refs.deliveryData.clear();
      vm.$refs.objectData.clear();
      vm.$refs.dc.clear();
      vm.values = [];
    },
    focus(ref) {
      if (ref) {
        return this.$refs[ref].focus();
      }
      this.$refs.senderData.focus();
    },
    hotkey(key) {
      this.$refs.servicesData.hotkey(key);
    },
    calculate() {
      const vm = this;
      if (
        !vm.$refs.senderData.ruleForm.cep ||
        !vm.$refs.deliveryData.ruleForm.cep ||
        vm.$refs.objectData.ruleForm.weight <= 0
      ) {
        return this.$message({
          duration: 5000,
          type: "error",
          message:
            "Para calculo dos valores é necessário informar o CEP Rementente, CEP Destinatário e Peso!",
          offset: 45,
        });
      }
      const data = {
        sourceZipcode:
          vm.$refs.senderData.ruleForm.cep +
          "|" +
          vm.$refs.senderData.ruleForm.address +
          " " +
          vm.$refs.senderData.ruleForm.number +
          " " +
          vm.$refs.senderData.ruleForm.neighborhood +
          " " +
          vm.$refs.senderData.ruleForm.city +
          " " +
          vm.$refs.senderData.ruleForm.state,
        destinyZipcode:
          vm.$refs.deliveryData.ruleForm.cep +
          "|" +
          vm.$refs.deliveryData.ruleForm.address +
          " " +
          vm.$refs.deliveryData.ruleForm.number +
          " " +
          vm.$refs.deliveryData.ruleForm.neighborhood +
          " " +
          vm.$refs.deliveryData.ruleForm.city +
          " " +
          vm.$refs.deliveryData.ruleForm.state,
        weight: vm.$refs.objectData.ruleForm.weight,
        customer: vm.$refs.senderData.ruleForm.customer || vm.licence,
        branch: null,
        format: vm.$refs.objectData.ruleForm.type,
        length: +vm.$refs.objectData.ruleForm.length,
        height: +vm.$refs.objectData.ruleForm.height,
        width: +vm.$refs.objectData.ruleForm.width,
        diameter: +vm.$refs.objectData.ruleForm.diameter,
        ownhand: vm.$refs.objectData.ruleForm.ownhand,
        valuedeclared: vm.$refs.objectData.ruleForm.valuedeclared,
        warning: vm.$refs.objectData.ruleForm.warning,
        digital: vm.$refs.objectData.ruleForm.ardigital,
        ap: vm.$refs.objectData.ruleForm.ap,
        sourceState: vm.$refs.senderData.ruleForm.state,
        destinyState: vm.$refs.deliveryData.ruleForm.state,
      };
      const loading = vm.$loading(vm.$options.loading);
      vm.values = [];
      ValuesPrepostService.values(data)
        .then((response) => {
          if (response.length === 0) {
            return this.$message({
              duration: 5000,
              type: "error",
              offset: 45,
              message:
                "Não foram encontrados serviços disponíveis para essas regiões!",
            });
          }
          this.available(response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    available(values) {
      const vm = this;
      for (const row of values) {
        row.data = {
          service: row.service,
          source: vm.$refs.senderData.ruleForm.cep,
          destiny: vm.$refs.deliveryData.ruleForm.cep,
          weidth: vm.$refs.objectData.ruleForm.weight,
          format: vm.$refs.objectData.ruleForm.type,
          length: +vm.$refs.objectData.ruleForm.length,
          height: +vm.$refs.objectData.ruleForm.height,
          width: +vm.$refs.objectData.ruleForm.width,
          diameter: +vm.$refs.objectData.ruleForm.diameter,
          ownhand: vm.$refs.objectData.ruleForm.ownhand,
          digital: vm.$refs.objectData.ruleForm.ardigital,
          valuedeclared: vm.$refs.objectData.ruleForm.valuedeclared,
          warning: vm.$refs.objectData.ruleForm.warning,
          ap: vm.$refs.objectData.ruleForm.ap,
          customer: vm.$refs.senderData.ruleForm.customer || vm.licence,
          branch: null,
          sourceState: vm.$refs.senderData.ruleForm.state,
          destinyState: vm.$refs.deliveryData.ruleForm.state,
        };
        vm.values.push(row);
      }
    },
    create(service, shipping, action) {
      const vm = this;
      if (!service) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "Selecione o serviço desejado!",
        });
      }

      // Validate declared value for nextday/sameday services
      const selectedServiceData = vm.values.find(x => x.service === service);
      const isNextDayOrSameDay = selectedServiceData &&
        ['samedayexpress', 'sameday', 'nextday', 'nextdayhub'].includes(selectedServiceData.code);

      if (isNextDayOrSameDay) {
        const declaredValue = vm.$refs.objectData.ruleForm.valuedeclared;
        if (!declaredValue || declaredValue <= 0) {
          return this.$message({
            type: "error",
            duration: 5000,
            message: "Para este serviço é obrigatório informar um valor declarado",
            offset: 45,
          });
        }
      }

      if (!vm.$refs.senderData.ruleForm.number) {
        this.$message({
          type: "error",
          duration: 5000,
          message: "Número do endereço de rementente dever ser informado!",
          offset: 45,
        });
        vm.$refs.senderData.next({
          target: { dataset: { next: "number" } },
        });
        return false;
      }
      if (!vm.$refs.deliveryData.ruleForm.number) {
        this.$message({
          type: "error",
          duration: 5000,
          message: "Número do endereço de destinatário dever ser informado!",
          offset: 45,
        });
        vm.$refs.deliveryData.next({
          target: { dataset: { next: "number" } },
        });
        return false;
      }
      // Validação NF-e: se chave preenchida, exigir DV válido + Número/Série/Valor
      const objForm = vm.$refs.objectData.ruleForm;
      if (objForm.typeContent === "1" && objForm.nfeKey) {
        const nfeKey = String(objForm.nfeKey).replace(/\D/g, "");
        if (nfeKey.length !== 44) {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: "A chave da nota fiscal deve conter 44 dígitos.",
          });
          return false;
        }
        if (!vm.$refs.objectData.isValidNfeKey(nfeKey)) {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: "A chave da nota fiscal informada é inválida. Verifique se foi digitada corretamente.",
          });
          return false;
        }
        const missing = [];
        if (!objForm.nfeNumber) missing.push("Número");
        if (!objForm.nfeSerie) missing.push("Série");
        if (!objForm.nfeValue || Number(objForm.nfeValue) === 0) missing.push("Valor da Nota");
        if (missing.length) {
          const list = missing.length === 1
            ? missing[0]
            : missing.slice(0, -1).join(", ") + " e " + missing[missing.length - 1];
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: `Ao informar a chave da nota fiscal, também ${missing.length > 1 ? "são obrigatórios os campos" : "é obrigatório o campo"}: ${list}.`,
          });
          return false;
        }
      }
      // Validação DC-E: se código preenchido, exigir DV válido + Valor da Nota
      if (objForm.typeContent === "2" && objForm.dceId) {
        const dceCode = String(objForm.dceId).replace(/\D/g, "");
        if (dceCode.length !== 44) {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: "O código da DC-E deve conter 44 dígitos.",
          });
          return false;
        }
        if (!vm.$refs.objectData.isValidNfeKey(dceCode)) {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: "O código da DC-E informado é inválido. Verifique se foi digitado corretamente.",
          });
          return false;
        }
        if (!objForm.nfeValue || Number(objForm.nfeValue) === 0) {
          this.$message({
            type: "error",
            duration: 5000,
            offset: 45,
            message: "Ao informar o código da DC-E, também é obrigatório o campo: Valor da DC-E.",
          });
          return false;
        }
      }
      if (shipping) {
        const vm = this;
        const loading = vm.$loading(vm.$options.loading);
        const data = {
          sender: {
            contact: vm.name,
            cep: vm.customer.zipcode.zipcode,
            address: vm.customer.address || vm.customer.zipcode.address,
            neighborhood:
              vm.customer.neighborhood || vm.customer.zipcode.neighborhood,
            city: vm.customer.city || vm.customer.zipcode.city,
            state: vm.customer.state || vm.customer.zipcode.state,
            number: vm.customer.number,
            extent: vm.customer.extent,
            phone: vm.phone,
            federalId: vm.customer.federalid,
          },
          delivery: [
            {
              name: vm.$refs.deliveryData.ruleForm.name,
              cep: vm.$refs.deliveryData.ruleForm.cep,
              address: vm.$refs.deliveryData.ruleForm.address,
              neighborhood: vm.$refs.deliveryData.ruleForm.neighborhood,
              city: vm.$refs.deliveryData.ruleForm.city,
              state: vm.$refs.deliveryData.ruleForm.state,
              number: vm.$refs.deliveryData.ruleForm.number,
              extent: vm.$refs.deliveryData.ruleForm.extent,
              phone: vm.$refs.deliveryData.ruleForm.phone,
              federalid: vm.$refs.deliveryData.ruleForm.federalid,
              weight: vm.$refs.objectData.ruleForm.weight,
              height: vm.$refs.objectData.ruleForm.height,
              width: vm.$refs.objectData.ruleForm.width,
              length: vm.$refs.objectData.ruleForm.length,
              value: vm.$refs.objectData.ruleForm.valuedeclared,
              observation: `${vm.$refs.deliveryData.ruleForm.care} ${vm.$refs.deliveryData.ruleForm.observation}`,
            },
          ],
          object: {
            weight: vm.$refs.objectData.ruleForm.weight,
            height: vm.$refs.objectData.ruleForm.height,
            width: vm.$refs.objectData.ruleForm.width,
            length: vm.$refs.objectData.ruleForm.length,
            value: vm.$refs.objectData.ruleForm.valuedeclared,
          },
          customer: vm.$refs.senderData.ruleForm.customer || vm.licence,
          nf: {
            nfeValue: vm.$refs.objectData.ruleForm.nfeValue,
            nfeNumber: vm.$refs.objectData.ruleForm.nfeNumber,
            nfeSerie: vm.$refs.objectData.ruleForm.nfeSerie,
            nfeKey: vm.$refs.objectData.ruleForm.nfeKey,
          },
        };
        MotoboyService.calculate(data)
          .then((response) => {
            const valueData = response.find((x) => x.id === service);
            if (!valueData) {
              return this.$message({
                type: "error",
                message:
                  "Não foi possivel achar a precificação para o serviço!",
              });
            }
            vm.$bus.$emit("pdv.created", {
              tag: valueData.id,
              sourceZipcode: vm.$refs.senderData.ruleForm.cep,
              destinyZipcode: vm.$refs.deliveryData.ruleForm.cep,
              value: +valueData.pricetable,
              service: service,
              name: vm.$refs.deliveryData.ruleForm.name,
              federalid: vm.$refs.deliveryData.ruleForm.federalid,
              type: "motoboy",
              state: "add",
              action: action,
              status: "add",
              content: vm.dc,
              calculateData: data,
            });
            if (action === "request") {
              this.$message({
                type: "success",
                message: "Motoboy solicitado com sucesso!",
              });
            } else {
              this.$message({
                type: "success",
                message: "Destinatário adicionado com sucesso!",
              });
            }
            vm.$refs.deliveryData.clear();
            vm.$refs.objectData.clear();
            vm.$refs.dc.clear();
            vm.$refs.deliveryData.focus();
            vm.values = [];
            vm.dc = [];
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      } else {
        const loading = vm.$loading(vm.$options.loading);

        const selectedServiceData = vm.values.find(
          (x) => x.service === service
        );
        const pricetable = (selectedServiceData && selectedServiceData.value) || 0;
        console.log("do create");

        PrepostService.add(
          vm.$refs.senderData.ruleForm.customer || vm.licence,
          {
            contact: vm.$refs.senderData.ruleForm.contact || vm.name,
            cep: vm.$refs.senderData.ruleForm.cep,
            address: vm.$refs.senderData.ruleForm.address,
            neighborhood: vm.$refs.senderData.ruleForm.neighborhood,
            city: vm.$refs.senderData.ruleForm.city,
            state: vm.$refs.senderData.ruleForm.state,
            number: vm.$refs.senderData.ruleForm.number,
            extent: vm.$refs.senderData.ruleForm.extent,
            federalId: vm.$refs.senderData.ruleForm.federalid,
          },
          {
            name: vm.$refs.deliveryData.ruleForm.name,
            cep: vm.$refs.deliveryData.ruleForm.cep,
            address: vm.$refs.deliveryData.ruleForm.address,
            neighborhood: vm.$refs.deliveryData.ruleForm.neighborhood,
            city: vm.$refs.deliveryData.ruleForm.city,
            state: vm.$refs.deliveryData.ruleForm.state,
            number: vm.$refs.deliveryData.ruleForm.number,
            extent: vm.$refs.deliveryData.ruleForm.extent,
          },
          {
            phone: vm.$refs.deliveryData.ruleForm.phone,
            mail: vm.mail,
            care: vm.$refs.deliveryData.ruleForm.care,
            observation: vm.$refs.deliveryData.ruleForm.observation,
            federalid: vm.$refs.deliveryData.ruleForm.federalid,
            invoice: "",
            request: "",
            note: "pdv",
            save: false,
          },
          {
            ar: vm.$refs.objectData.ruleForm.warning,
            ownhand: vm.$refs.objectData.ruleForm.ownhand,
            weight: vm.$refs.objectData.ruleForm.weight,
            ardigital: vm.$refs.objectData.ruleForm.ardigital,
            ap: vm.$refs.objectData.ruleForm.ap,
            mdp: "",
            quantity: +vm.$refs.objectData.ruleForm.quantity,
          },
          vm.volumes.length == 0
            ? {
                height: vm.$refs.objectData.ruleForm.height,
                width: vm.$refs.objectData.ruleForm.width,
                length: vm.$refs.objectData.ruleForm.length,
                diameter: vm.$refs.objectData.ruleForm.diameter,
                value: vm.$refs.objectData.ruleForm.valuedeclared,
                total: vm.$refs.objectData.ruleForm.valuedeclared,
                type: vm.$refs.objectData.ruleForm.type,
                nfeKey: vm.$refs.objectData.ruleForm.nfeKey,
                nfeNumber: vm.$refs.objectData.ruleForm.nfeNumber,
                nfeSerie: vm.$refs.objectData.ruleForm.nfeSerie,
                nfeValue: vm.$refs.objectData.ruleForm.nfeValue,
                dceId: vm.$refs.objectData.ruleForm.dceId,
                typeContent: vm.$refs.objectData.ruleForm.typeContent,
              }
            : vm.volumes.map((x) => {
                return {
                  height: x.height,
                  width: x.width,
                  length: x.length,
                  diameter: vm.$refs.objectData.ruleForm.diameter,
                  value: vm.$refs.objectData.ruleForm.valuedeclared,
                  total: vm.$refs.objectData.ruleForm.valuedeclared,
                  type: vm.$refs.objectData.ruleForm.type,
                  nfeKey: vm.$refs.objectData.ruleForm.nfeKey,
                  nfeNumber: vm.$refs.objectData.ruleForm.nfeNumber,
                  nfeSerie: vm.$refs.objectData.ruleForm.nfeSerie,
                  nfeValue: vm.$refs.objectData.ruleForm.nfeValue,
                  dceId: vm.$refs.objectData.ruleForm.dceId,
                  typeContent: vm.$refs.objectData.ruleForm.typeContent,
                };
              }),
          service,
          "",
          vm.dc,
          {
            nfeKey: vm.$refs.objectData.ruleForm.nfeKey,
            nfeNumber: vm.$refs.objectData.ruleForm.nfeNumber,
            nfeSerie: vm.$refs.objectData.ruleForm.nfeSerie,
            nfeValue: vm.$refs.objectData.ruleForm.nfeValue,
          },
          '',
          pricetable
        )
          .then((response) => {
            this.$message({
              type: "success",
              message: `Prepostagem adicionada com sucesso!`,
              offset: 45,
            });
            for (const prepostData of response) {
              vm.$bus.$emit("pdv.created", {
                tag: prepostData.tag,
                sourceZicode: vm.$refs.senderData.ruleForm.cep,
                deliveryZicode: vm.$refs.deliveryData.ruleForm.cep,
                value: +prepostData.pricetable,
                service: service,
                name: vm.$refs.deliveryData.ruleForm.name,
                federalid: vm.$refs.deliveryData.ruleForm.federalid,
                type: "prepost",
                state: "add",
              });
            }
            vm.$refs.deliveryData.clear();
            vm.$refs.objectData.clear();
            vm.$refs.dc.clear();
            vm.$refs.deliveryData.focus();
            vm.values = [];
            vm.dc = [];
          })
          .catch((error) => {
            this.$message({
              type: "error",
              duration: 5000,
              message: error,
              offset: 45,
            });
          })
          .finally(() => loading.close());
      }
    },
  },
};
</script>

<style>
.icon-large {
  height: 40px;
}
</style>

<style scoped>
/* Cada etapa da postagem é um bloco: o título (divider) fica em largura cheia
   e o conteúdo/inputs recebe recuo lateral, segmentando o formulário longo. */
.pdv-delivery-wrap {
  width: 100%;
}

.pdv-panel {
  padding: 0 24px;
  margin-bottom: 24px;
}

/* o título da seção volta à largura total do bloco */
.pdv-panel >>> .el-divider--horizontal {
  margin-left: -24px;
  margin-right: -24px;
  width: auto;
}

.pdv-panel >>> .el-divider__text {
  font-weight: 600;
  color: #303133;
}
</style>
